<template>
  <div id="app">
    <coin-dog-header></coin-dog-header>
    <router-view/>
    <coin-dog-footer></coin-dog-footer>
  </div>
</template>

<script>
import CoinDogHeader from '@/components/common/CoinDogHeader'
import CoinDogFooter from '@/components/common/CoinDogFooter'
export default {
  name: 'App',
  components: {
    CoinDogHeader,
    CoinDogFooter
  }
}
</script>

<style lang="scss">
</style>
